module.exports = __webpack_public_path__ + "sprite/buttons@2x.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/buttons@2x.json
// module id = 123
// module chunks = 3